document.addEventListener("DOMContentLoaded", function () {
  console.log("[Langify Polyfill] DOM loaded");

  const checkForLangify = setInterval(function () {
    const apiObserver = window?.langify?.api?.observer;

    if (typeof apiObserver === 'function') {
      console.log("[Langify Polyfill] langify.api.observer found — executing");
      apiObserver('[data-lfy-translatable="true"]');
      clearInterval(checkForLangify);
    } else {
      console.log("[Langify Polyfill] Waiting for langify.api.observer...");
    }
  }, 500); // check every 500ms

  // Optional: stop checking after 10 seconds
  setTimeout(() => {
    clearInterval(checkForLangify);
    if (typeof window?.langify?.api?.observer !== 'function') {
      console.warn("[Langify Polyfill] langify.api.observer still not available after timeout");
    }
  }, 10000);
});
